import { AutoShipOption, Prescription, PrescriptionAction, PrescriptionProduct } from './types'

export const prescriptionBuilderActions = {
  remove: (sku: string): PrescriptionAction => ({ type: 'remove', sku: sku.toUpperCase() }),
  updateQuantity: (sku: string, quantity: number): PrescriptionAction => ({
    type: 'updateQuantity',
    sku: sku.toUpperCase(),
    quantity,
  }),
  updateAutoShip: (sku: string, autoShip: AutoShipOption): PrescriptionAction => ({
    type: 'updateAutoShip',
    sku: sku.toUpperCase(),
    autoShip,
  }),
  setPromoCode: (code: string): PrescriptionAction => ({ type: 'setPromoCode', promoCode: code }),
  add: (product: PrescriptionProduct): PrescriptionAction => ({
    type: 'add',
    product: { ...product, sku: product.sku.toUpperCase() },
  }),
  addMany: (products: PrescriptionProduct[]): PrescriptionAction => {
    return {
      type: 'addMany',
      products: products.map((product) => ({ ...product, sku: product.sku.toUpperCase() })),
    }
  },
  updateProduct: (sku: string, product: PrescriptionProduct): PrescriptionAction => ({
    type: 'updateProduct',
    sku: sku.toUpperCase(),
    product: { ...product, sku: product.sku.toUpperCase() },
  }),
  clearAll: (): PrescriptionAction => {
    return {
      type: 'clearAll',
    }
  },
  set: (prescription: Prescription): PrescriptionAction => ({
    type: 'set',
    prescription,
  }),
}
